import { InputAdornment, CircularProgress } from "@mui/material";
import { MuiButton } from '../../../../Components/Form';
import HookEnrollCourse from '../../../../hooks/EnrollCourse';
import { info, Succ, succses } from '../../../../images';
import { useEffect } from "react";
import {  useSelector } from "react-redux";

const InputProps = () => {
    const Load = useSelector((state) => state.EnrollCourse.loading)
    const Sucdeed = useSelector((state) => state.EnrollCourse.status)

    const inputProps = {
        endAdornment: (
            <InputAdornment
                position="end"
            >
                {
                    Sucdeed ? <span style={{
                        padding: '7px', gap: '5px',
                        display: 'flex', alignItems: 'center', backgroundColor: ' #27AE601A', color: "#27AE60"
                    }} > <img src={Succ} alt="" /> تم تطبيق الرمز </span> : Load ? <CircularProgress style={{ padding: '5px' }} /> : < MuiButton type='submit' height="30px" text="تطبيق" />
                }


                {/* <ClearIcon style={{ display: showCancel }} onClick={handleClick} /> */}
            </InputAdornment>
        )
    }
    return { inputProps }
}

export default InputProps